import React from "react";
import { Clock } from "lucide-react";
import { generateTimeSlots, getServicePeriod } from "@/utils/scheduleUtils";
import ReservationCard from "@/components/ReservationCard";

const TimelineView = ({ date, reservations, onReservationClick, onStatusChange }) => {
  const timeSlots = generateTimeSlots(date);
  const dayOfWeek = date.getDay();

  // Group reservations by time
  const reservationsByTime = {};
  reservations.forEach(reservation => {
    const time = reservation.time.substring(0, 5); // Get HH:MM
    if (!reservationsByTime[time]) {
      reservationsByTime[time] = [];
    }
    reservationsByTime[time].push(reservation);
  });

  // Detect service period changes
  let currentService = null;

  return (
    <div className="h-full overflow-auto scroll-container bg-[#09090B]">
      <div className="min-w-[800px]">
        {timeSlots.map((timeSlot, index) => {
          const servicePeriod = getServicePeriod(timeSlot, dayOfWeek);
          const showServiceHeader = servicePeriod !== currentService;
          currentService = servicePeriod;

          const slotReservations = reservationsByTime[timeSlot] || [];

          return (
            <React.Fragment key={timeSlot}>
              {/* Service Period Header */}
              {showServiceHeader && (
                <div className="sticky top-0 z-10 bg-[#18181B] border-b-2 border-[#22C55E] px-4 py-1.5">
                  <h3 className="text-xs font-bold text-[#22C55E] uppercase tracking-wider">
                    {servicePeriod}
                  </h3>
                </div>
              )}

              {/* Time Slot Row */}
              <div
                className={`
                  flex items-start gap-3 px-4 py-2
                  border-b border-[#27272A]/30
                  hover:bg-[#18181B]/20
                  transition-colors
                `}
              >
                {/* Time Label - More prominent, no icon */}
                <div className="w-16 flex-shrink-0 pt-0.5">
                  <span className="font-mono text-base text-[#FAFAFA] font-bold">
                    {timeSlot}
                  </span>
                </div>

                {/* Reservations Area - Only show if there are reservations */}
                {slotReservations.length > 0 && (
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap gap-2">
                      {slotReservations.map((reservation) => (
                        <ReservationCard
                          key={reservation.booking_id}
                          reservation={reservation}
                          onClick={onReservationClick}
                          onStatusChange={onStatusChange}
                          compact={true}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </React.Fragment>
          );
        })}

        {/* Empty State */}
        {timeSlots.length === 0 && (
          <div className="flex flex-col items-center justify-center h-64 text-center p-6">
            <Clock className="w-16 h-16 text-[#27272A] mb-4" />
            <p className="text-lg text-[#A1A1AA]">Restaurant is closed on this day</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineView;
